(() => {
  const init = scope => {
    scope.querySelectorAll('[data-rnl-collection-controls]').forEach(form => {
      if (form.dataset.rnlControlsReady) return;
      form.dataset.rnlControlsReady = 'true';
      const select = form.querySelector('select[name="sort_by"]');
      const allowed = select ? Array.from(select.options, option => option.value) : ['manual'];
      const selectedSort = () => select ? select.value : 'manual';
      const clean = url => {
        Array.from(url.searchParams.keys()).forEach(key => {
          if (key === 'filter.v.availability') url.searchParams.delete(key);
        });
        return url;
      };
      const current = new URL(location.href);
      const normalized = clean(new URL(current.href));
      if (!allowed.includes(form.dataset.rnlCurrentSort)) {
        normalized.searchParams.set('sort_by', selectedSort());
        normalized.searchParams.delete('page');
      }
      if (normalized.href !== current.href) {
        location.replace(normalized.href);
        return;
      }
      const min = form.querySelector('[data-rnl-price-min]');
      const max = form.querySelector('[data-rnl-price-max]');
      const validate = () => {
        if (!min || !max) return;
        max.setCustomValidity(min.value !== '' && max.value !== '' && Number(max.value) < Number(min.value) ? form.dataset.rnlPriceError : '');
      };
      min?.addEventListener('input', validate);
      max?.addEventListener('input', validate);
      const details = form.querySelector('[data-rnl-price-preview]');
      document.addEventListener('click', event => { if (details && !details.contains(event.target)) details.open = false; });
      form.addEventListener('keydown', event => { if (event.key === 'Escape' && details) details.open = false; });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const target = clean(new URL(location.href));
        if (min && max) {
          [min, max].forEach(input => {
            if (input.value === '') target.searchParams.delete(input.name);
            else target.searchParams.set(input.name, input.value);
          });
        }
        target.searchParams.set('sort_by', selectedSort());
        target.searchParams.delete('page');
        location.assign(target.href);
      });
      select?.addEventListener('change', () => form.requestSubmit());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

